import RequireAdmin from "/src/features/auth/hooks/requireAdmin";
import ConfigurationPanelPage from "/src/features/administration/configuration/components/ConfigurationPanelPage/ConfigurationPanelPage";

function ConfigurationList() {
    return (
        <RequireAdmin>
            <ConfigurationPanelPage />
        </RequireAdmin>
    );
}

export default ConfigurationList;
